/* eslint-disable react/react-in-jsx-scope */
import { useState } from "react";
import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import AssetLocationsList from "./AssetLocationsList";

function AssetLocationSlider({ asset }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button
        variant="link"
        className="bg-transparent p-0"
        onClick={handleShow}
        size="sm"
      >
        Locations
      </Button>

      <Offcanvas
        style={{ width: "700px" }}
        show={show}
        onHide={handleClose}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Asset Locations List</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <AssetLocationsList selectedAsset={asset} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AssetLocationSlider;
